import React from 'react';
import { monsterClassFromId } from '../../../monsters';
import { Trans } from '@lingui/macro';

export default function ChangingTurnAnimated(props) {
  return <div>
    <div className={`game-sprite changing-turn-monster-image ${monsterClassFromId(props.monsterId)}`}></div>
    <div className="changing-turn-player-name">
      {props.isGameStart === false
        ? <Trans>{props.playerName}'s turn</Trans>
        : <Trans>{props.playerName} starts!</Trans>
      }
    </div>
  </div>;
}
